import React from 'react';

const ChevronDownIcon = ({ size = 14 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    style={{ width: size, height: size }}
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export default ChevronDownIcon;
